import React, { useState } from 'react'
import Main from '../../cpn/Main'
import { Button, Form, Input, message } from 'antd'
import { useShangpinjiaochengAddMutation } from '../../store/dianshangtaizhangApi';
import MyEditor from '../../cpn/MyEditor';
function GoodsCourseAdd() {
    const [form] = Form.useForm(); 
    const [submit] = useShangpinjiaochengAddMutation();
    const [info,setInfo] = useState({
        spdd_content:''
    })
    return (
        <Main selectedKeys={['/GoodsCourseAdd']}>
            <Form
                form={form}
                layout="horizonal"
                name="form_client"
                initialValues={{modifier: 'public',}}
                labelCol={{ span: 3 }}   
                onFinish={() => {
                    submit({
                        "spjc_name" : info.spjc_name,
                        "spjc_remark" : info.spjc_remark,
                        "spjc_content" : info.spjc_content,
                    }).then((res) => {
                        // console.log(res);
                        if (res.data.Status === 'success') {                            
                            message.success('新增成功！')   
                            form.resetFields();                          
                        }
                        if (res.data.Status === 'fail') {
                            message.error('新增失败！'+res.data.Message)
                        }
                    }) 
                }}                 
            >                                                       
                 
                <Form.Item name="spdd_content" wrapperCol={{span:10}} label='教程名称' required>                        
                    <Input onChange={(e) => {
                        setInfo(prevState=>({...prevState,spjc_name:e.target.value}))
                    }}/>
                </Form.Item> 
                <Form.Item name="spjc_remark" label='教程介绍' wrapperCol={{span:15}} >
                    <MyEditor onChange={(e) => {setInfo(prevState=>({...prevState,spjc_remark:e}))}} value={info.spjc_remark}/>
                </Form.Item>
                <Form.Item name="spjc_content" label='教程' wrapperCol={{span:15}} >
                    <MyEditor onChange={(e) => {setInfo(prevState=>({...prevState,spjc_content:e}))}} value={info.spjc_content}/>
                </Form.Item>
                <Form.Item wrapperCol={{offset:3}} >                        
                    <Button type='primary' htmlType='submit'>提交</Button>
                </Form.Item>
            </Form>
        </Main>
    )
}

export default GoodsCourseAdd